import { render } from "./UpdateContactForm.vue?vue&type=template&id=3f165e1b&scoped=true"
import script from "./UpdateContactForm.vue?vue&type=script&lang=js"
export * from "./UpdateContactForm.vue?vue&type=script&lang=js"

import "./UpdateContactForm.vue?vue&type=style&index=0&id=3f165e1b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f165e1b"]])

export default __exports__